import { render, staticRenderFns } from "./ChoiceList.vue?vue&type=template&id=6027fc81&scoped=true&"
import script from "./ChoiceList.vue?vue&type=script&lang=js&"
export * from "./ChoiceList.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceList.vue?vue&type=style&index=0&id=6027fc81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6027fc81",
  null
  
)

export default component.exports